var CustomEvents = {
    GTM_CLIENT_READY: 'gtmClientReady'
};
export default CustomEvents;
